import Rodal from './Rodal/rodal';
import './Rodal/rodal.css';
import ModalPopup from "@system/chain/modal-popup";
import React, { useState, useEffect } from "react";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export const ModalChaining = () => {
    const [{ system_notification, latest_system_notification_name, latest_system_notification_UUID }, { }, { }] = useDOMAttachToSystemStore();
    const [ModalPopupStatus, SetModalPopupStatus] = useState(false);

    useEffect(() => {
        SetModalPopupStatus(true);
    }, [latest_system_notification_UUID]);

    return (
        <>
            {ModalPopup.chain.map((v) => (
                <React.Fragment key={v.name + latest_system_notification_UUID}>
                    {latest_system_notification_name === v.name &&
                        <>
                            {/* {!v.legacy_load &&
                                <> */}
                            <Modal show={ModalPopupStatus} onHide={() => { SetModalPopupStatus(false) }}>
                                {React.createElement(v.element, {
                                    ...system_notification[latest_system_notification_name],
                                    SetStatus: SetModalPopupStatus
                                })}
                            </Modal>
                            {/* </>
                            } */}
                            {/* {v.legacy_load &&
                                <>
                                    {console.log("down")}
                                    {React.createElement(v.element, {
                                        ...system_notification[latest_system_notification_name],
                                        SetStatus: SetModalPopupStatus,
                                        setStatus: SetModalPopupStatus,
                                        status: ModalPopupStatus,
                                    })}
                                </>
                            } */}
                        </>
                    }
                </React.Fragment>
            ))}
        </>
    )
};
const Modal = (props) => {
    const { show } = props;
    const [{ latest_system_notification_UUID }, { }, { }] = useDOMAttachToSystemStore();
    useEffect(() => {
        if (show === true) {
            document.body.style.overflow = 'hidden';
        }
        if (show === false) {
            document.body.style.overflow = '';
        }
    }, [show, latest_system_notification_UUID]);
    return (
        <>
            <Rodal visible={props.show} isDrag={props.isDrag} isDisabled={props.isDisabled} onClose={() => {
                props.onHide();
            }}>
                {props.children}
            </Rodal>
        </>
    );
};

export default Modal;